import type { ComponentType, SVGProps } from 'react'
import { useWeather } from '../hooks/useWeather'
import { Sun, CloudSun, Cloud, CloudRain, CloudSnow, Cloudy } from '../icons'

function iconFor(code: number): ComponentType<SVGProps<SVGSVGElement>> {
  if (code === 0) return Sun
  if (code <= 3) return CloudSun
  if (code <= 48) return Cloud
  if (code <= 67) return CloudRain
  if (code <= 77) return CloudSnow
  return Cloudy
}

function descriptionFor(code: number): string {
  if (code === 0) return 'Sereno'
  if (code <= 2) return 'Parzialmente nuvoloso'
  if (code === 3) return 'Nuvoloso'
  if (code <= 48) return 'Nebbia'
  if (code <= 57) return 'Pioviggine'
  if (code <= 67) return 'Pioggia'
  if (code <= 77) return 'Neve'
  if (code <= 82) return 'Rovesci'
  if (code <= 86) return 'Rovesci di neve'
  return 'Temporale'
}

const WEEK_SHORT_IT = ['Dom', 'Lun', 'Mar', 'Mer', 'Gio', 'Ven', 'Sab'] as const

function shortDayLabel(date: string, tomorrow: boolean): string {
  const d = new Date(`${date}T00:00:00`)
  const day = WEEK_SHORT_IT[d.getDay()]
  return tomorrow ? `Domani · ${day}` : day
}

export function WeatherCard() {
  const { data, isLoading } = useWeather()
  if (isLoading || !data) {
    return <div className="weather" style={{ height: 110 }}><div className="sk" style={{ width: '100%', height: '100%' }} /></div>
  }
  const Icon = iconFor(data.current.code)
  const todayForecast = data.forecast[0]
  const nextDays = data.forecast.slice(1, 3)

  return (
    <div className="weather">
      <div className="weather__now">
        <div className="weather__temp">{data.current.temp}<sup>°C</sup></div>
        <div className="weather__city">
          <div className="weather__city-name">{data.city}</div>
          <div className="weather__city-meta">
            <Icon />
            <span>{descriptionFor(data.current.code)}</span>
          </div>
          {todayForecast && (
            <div className="weather__city-meta" style={{ marginTop: 2 }}>
              <span className="hi-lo">↑ {todayForecast.max}° · ↓ {todayForecast.min}°</span>
            </div>
          )}
        </div>
      </div>
      <div className="weather__forecast">
        {nextDays.map((d, i) => {
          const DayIcon = iconFor(d.code)
          return (
            <div key={d.date} className="weather__day">
              <div className="weather__day-label">{shortDayLabel(d.date, i === 0)}</div>
              <div className="weather__day-row">
                <DayIcon />
                <span className="weather__day-temps">{d.max}° <span className="lo">/ {d.min}°</span></span>
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}
